// ~/mimi-network-mvp/shared/design-system/AiBentoLogo.tsx
// Official AI Bento Logo - Pure Visual Component
// Separated from functionality for maximum reusability

import React from 'react';
import { BENTO_ICON_COLORS } from './colors';

export interface AiBentoLogoProps {
  size?: number;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Official Mimi Network Logo (AI Bento Three-Box Design)
 * 
 * Pure visual component with no functionality
 * Features: 3 horizontal lines + 2 wasabi green dots
 * Colors: Always vibrant (nori lines + wasabi dots)
 * 
 * Usage:
 * import { MimiLogo } from '../shared/design-system/MimiLogo';
 * <MimiLogo size={64} />
 */
export const AiBentoLogo: React.FC<AiBentoLogoProps> = ({ 
  size = 32, 
  className = "",
  style = {}
}) => {
  return (
    <svg 
      width={size} 
      height={Math.round(size * 23/48)} 
      viewBox="0 0 48 23" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      {/* 
        OFFICIAL AI BENTO LOGO DESIGN: 
        - Three horizontal lines: 28px wide × 2px high
        - Two dots: 8px diameter (r=4), positioned at y=8.5
        - Layout: Top (y=0) → Dots (y=8.5) → Middle (y=15) → Bottom (y=20)
        - Always vibrant colors (no gray states)
      */}
      
      {/* Top horizontal line */}
      <rect 
        x="10" 
        y="0" 
        width="28" 
        height="2" 
        rx="1" 
        fill={BENTO_ICON_COLORS.lines}  // #47482E (nori)
      />
      
      {/* Middle horizontal line */}
      <rect 
        x="10" 
        y="15" 
        width="28" 
        height="2" 
        rx="1" 
        fill={BENTO_ICON_COLORS.lines}  // #47482E (nori)
      />
      
      {/* Bottom horizontal line */}
      <rect 
        x="10" 
        y="20" 
        width="28" 
        height="2" 
        rx="1" 
        fill={BENTO_ICON_COLORS.lines}  // #47482E (nori)
      />
      
      {/* Left wasabi dot */}
      <circle 
        cx="16" 
        cy="8.5" 
        r="4" 
        fill={BENTO_ICON_COLORS.dots}  // #8EB700 (wasabi)
      />
      
      {/* Right wasabi dot */}
      <circle 
        cx="32" 
        cy="8.5" 
        r="4" 
        fill={BENTO_ICON_COLORS.dots}  // #8EB700 (wasabi)
      />
    </svg>
  );
};

export default AiBentoLogo;
